import React from 'react'

import { Box, Tabs } from '@factorialco/deprecated-design-system'

import type { PurchaseOrderDetailFieldsFragment } from 'generated/resources/graphql'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'
import i18n from 'modules/core/lib/i18n'

import Attachments from './Attachments'
import Summary from './Summary'

interface Props {
  purchaseOrder: PurchaseOrderDetailFieldsFragment
  currentTab: string
  onTabChange: (tabId: string) => void
}

const PurchaseOrderDetailPanel = ({ purchaseOrder, currentTab, onTabChange }: Props) => {
  return (
    <ErrorBoundary>
      <Box paddingTop="s6" overflowY="hidden">
        <Tabs
          currentId={currentTab}
          tabsAlign="flexStart"
          onTabClicked={onTabChange}
          hasAdditionalPadding
        >
          <Tabs.Tab id="summary" label={i18n.t('procurement.purchase_orders.detail.tabs.summary')}>
            <Summary purchaseOrder={purchaseOrder} />
          </Tabs.Tab>
          <Tabs.Tab
            id="attachments"
            label={i18n.t('procurement.purchase_orders.detail.tabs.invoices')}
          >
            <Attachments
              purchaseOrderId={purchaseOrder.id}
              vendorId={purchaseOrder?.vendor?.id ?? undefined}
            />
          </Tabs.Tab>
        </Tabs>
      </Box>
    </ErrorBoundary>
  )
}

export default PurchaseOrderDetailPanel
